import isBnn from '@/config/isBnn'

export const BU_TYPE = Object.freeze({
  STUDIO7: 'STUDIO7',
  BNN: 'BNN',
})

// The business unit this build serves
export const currentBu = isBnn ? BU_TYPE.BNN : BU_TYPE.STUDIO7

const DOMAINS = {
  [BU_TYPE.STUDIO7]: process.env.VUE_APP_STUDIO7_URL,
  [BU_TYPE.BNN]: process.env.VUE_APP_BNN_URL,
}

export const getBuDomain = type =>
  (DOMAINS[type] || '').replace(/\/+$/, '')

export const buildOrderDetailUrl = (type, uuid) =>
  `${getBuDomain(type)}/order-detail/${uuid}`
